module.exports = __webpack_public_path__ + "static/media/ic_arrow_right.06be2ddb.svg";